'use strict';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/mergeMap';
import {epicErrorHandler} from '../../core-utilities/rx-utils';
import {hidePanel, showPanel} from '../actions/notificationsActions';
import {logger} from './logger';

export const epics = [
  onShowNotificationPanel,
  onHideNotificationPanel,
];

onShowNotificationPanel.$inject = onHideNotificationPanel.$inject = [
  'NotificationService',
];

/**
 * @param {ActionsObservable<ReduxAction>} action$
 * @param {Store} store
 * @param dependencies
 */
export function onShowNotificationPanel(action$, store, dependencies) {
  return action$.ofType(showPanel.TYPE)
    .do(() => dependencies.NotificationService.showNotifications())
    .filter(() => false)
    .catch(epicErrorHandler(logger, 'onDeleteItem'));
}

/**
 * @param {ActionsObservable<ReduxAction>} action$
 * @param {Store} store
 * @param dependencies
 */
export function onHideNotificationPanel(action$, store, dependencies) {
  return action$.ofType(hidePanel.TYPE)
    .do(() => dependencies.NotificationService.hideNotifications())
    .filter(() => false)
    .catch(epicErrorHandler(logger, 'onDeleteItem'));
}



// WEBPACK FOOTER //
// ./src/js/system/epics/onShowHideNotificationPanel.js